// extracted by mini-css-extract-plugin
export default {"Media":"Media_Media__HT3s9","Media__slideshow":"Media_Media__slideshow__Wfy3p","Media__audio":"Media_Media__audio__XPdSa","Media__video":"Media_Media__video__A9T1v"};